import React, { Component } from "react";
import bandit from "../images/cropped/bandit.avif";
import cauchy from "../images/cauchy.avif";
import dali from "../images/cropped/dali.avif";
import banner from "../images/cropped/all.avif";

const chinchillas = [
  {
    name: "Dalí",
    birthday: "06.03.2016",
    color: "White Mosaic",
    image: dali,
    altText: "Dalí the chinchilla sitting upright on a clay tunnel"
  },
  {
    name: "Cauchy",
    birthday: "11.03.2016",
    color: "Dark Ebony",
    image: cauchy,
    altText: "Cauchy the chinchilla sitting on the floor, in one hand holding an ear of what"
  },
  {
    name: "Bandit",
    birthday: "03.05.2016",
    color: "Brown Ebony",
    image: bandit,
    altText: "Bandit the chinchilla sitting on a platform in his cage holding a half-eaten cheerio"
  },
];

class TopBanner extends Component {
  getIntroCard = (chinchilla) => {
    return (
      <div className="intro-card" key={chinchilla.name}>
        <h2>{chinchilla.name}</h2>
        <p>{chinchilla.birthday}</p>
        <p>{chinchilla.color}</p>
        <img src={chinchilla.image} alt={chinchilla.altText} />

        {/* <button>More {chinchilla.name}</button> */}
      </div>
    );
  };

  render() {
    let introCards = chinchillas.map((chinch) => this.getIntroCard(chinch));

    return (
      <div className="top-banner" id="topBanner" ref={this.props.refName}>
        <div className="slider">
          <img src={banner} alt="The three chaos chinchillas climbing all over their owner's lap"/>
        </div>
        <div className="intro-cards">
          <h3>Introducing</h3>
          <div className="cards-wrapper">{introCards}</div>
          <div className="dots">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
        </div>
      </div>
    );
  }
}

export default TopBanner;
